import React, { useEffect, useState } from 'react';
import FooterQuoteDetailStyle from './style';
import { useDispatch, useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPhone,
    faEnvelope,
    faCircleLeft,
    faCircleRight,
} from '@fortawesome/free-solid-svg-icons';
import { Button, Flex } from 'antd';
import ModalSendMessage from 'src/components/modalSendMessage';
import { PHONE_YGT } from 'src/const/common';
import { formatPhoneNumber } from 'src/const/contain';
import useIsMobile from 'src/hooks/useIsMobile';
import { toggleEditQuoteSelector } from 'src/redux/selectors/toggleEditQuoteSelector';
import { multipleQuotesSelector } from 'src/redux/selectors/multipleQuotesSelector';
import { updateMultipleQuotesAction } from 'src/redux/actions/multipleQuotesAction';

interface FooterQuoteDetailProps {
    isPreview: boolean;
}

const FooterQuoteDetail: React.FC<FooterQuoteDetailProps> = ({ isPreview }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isFirstRender, setIsFirstRender] = useState(true);
    const isMobile: boolean = useIsMobile();

    const queryParams = new URLSearchParams(location.search);
    const quoteIdQuery = queryParams.get('id') || '';
    const queryParamsMultipleQuotes = queryParams.get('multipleQuotes');

    const { resConsultant, title } = useSelector(quoteDetailSelector);

    const { telephone } = resConsultant;

    const phone = telephone || PHONE_YGT;

    const isEdit = useSelector(toggleEditQuoteSelector);
    const { ids: quotesArray = [], currentId } = useSelector(
        multipleQuotesSelector,
    );
    const currentIndex: number = quotesArray.indexOf(currentId || '');

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRender(false);
        } else {
            setTimeout(
                () => {
                    let absoluteTop = 0;

                    const section = document.getElementById('quote-detail');

                    if (section && isMobile) {
                        const elementRect = section.getBoundingClientRect();
                        const absoluteElementTop =
                            elementRect.top + window.scrollY;
                        const absoluteElementPreview = isPreview ? 63 : 0;
                        let heightTitle = 0;
                        const sectionTitle: any =
                            document.getElementsByClassName(
                                'box-multiple-title',
                            );
                        if (sectionTitle && sectionTitle.length > 0) {
                            heightTitle = sectionTitle[0].offsetHeight;
                        }

                        absoluteTop =
                            absoluteElementTop -
                            (absoluteElementPreview + heightTitle) -
                            15;
                    }
                    window.scrollTo({
                        top: absoluteTop,
                        behavior: 'smooth',
                    });
                },
                location.pathname.includes('introduction') && isPreview
                    ? 500
                    : 0,
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, isMobile]);

    useEffect(() => {
        if (!isFirstRender) {
            let absoluteTop = 0;
            if (isMobile) {
                const sectionTitle: any =
                    document.getElementsByClassName('box-header');
                if (sectionTitle && sectionTitle.length > 0) {
                    const { height = 0, top = 0 } =
                        sectionTitle[0]?.getBoundingClientRect();
                    absoluteTop =
                        height + top + window.scrollY - (isPreview ? 63 : 0);
                }
            }
            window.scrollTo({
                top: absoluteTop,
                behavior: 'smooth',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title, isMobile, isPreview]);

    const isCheckPathName = (path: string) => {
        return location.pathname.includes(path);
    };

    const getPathName = () => {
        return 'introduction';
    };

    const handleNavigate = () => {
        let url = `/${
            isCheckPathName('quoteDetail') ? 'quoteDetail' : 'multipleQuotes'
        }/${
            isCheckPathName('itineraryInDetail')
                ? 'pricingAndBooking'
                : 'itineraryInDetail'
        }?id=${quoteIdQuery}${
            queryParamsMultipleQuotes
                ? `&multipleQuotes=${queryParamsMultipleQuotes}`
                : ''
        }`;

        navigate(url);
    };

    const phoneCall = () => {
        window.location.href = `tel:${phone}`;
    };

    const handleBack = () => {
        if (!isEdit) {
            let idQuote;
            if (currentIndex > 0) {
                idQuote = quotesArray[currentIndex - 1];
            } else {
                idQuote = quotesArray[quotesArray.length - 1];
            }
            if (isPreview) {
                navigate(
                    `/quoteDetail/${getPathName()}?id=${idQuote}&multipleQuotes=${queryParamsMultipleQuotes}`,
                );
            } else {
                navigate(
                    `/multipleQuotes/${getPathName()}?id=${queryParams.get(
                        'id',
                    )}`,
                );
                dispatch(
                    updateMultipleQuotesAction({
                        currentId: idQuote,
                    }),
                );
            }
        }
    };

    const handleNext = () => {
        if (!isEdit) {
            let idQuote;
            if (currentIndex < quotesArray.length - 1) {
                idQuote = quotesArray[currentIndex + 1];
            } else {
                idQuote = quotesArray[0];
            }

            if (isPreview) {
                navigate(
                    `/quoteDetail/${getPathName()}?id=${idQuote}&multipleQuotes=${queryParamsMultipleQuotes}`,
                );
            } else {
                navigate(
                    `/multipleQuotes/${getPathName()}?id=${queryParams.get(
                        'id',
                    )}`,
                );
                dispatch(
                    updateMultipleQuotesAction({
                        currentId: idQuote,
                    }),
                );
            }
        }
    };

    return (
        <FooterQuoteDetailStyle>
            <div className="container-ydp">
                <div className="box-footer">
                    <Button
                        type="primary"
                        className="btnLink"
                        onClick={handleNavigate}
                    >
                        {`See ${
                            isCheckPathName('itineraryInDetail')
                                ? 'your pricing and booking details'
                                : 'your golf trip in detail'
                        }`}
                    </Button>
                    <div className="">
                        <span className="link" onClick={phoneCall}>
                            Call me <FontAwesomeIcon icon={faPhone} />
                        </span>{' '}
                        <span className="hide-mobile">
                            on {formatPhoneNumber(phone)} to book
                        </span>{' '}
                        or{' '}
                        <span
                            className="link"
                            onClick={() => setIsModalVisible(true)}
                        >
                            Send a message <FontAwesomeIcon icon={faEnvelope} />
                        </span>
                    </div>
                    {quotesArray.length > 1 && (
                        <Flex className="quote-click" align="center" gap={16}>
                            <Flex
                                align="center"
                                gap={4}
                                onClick={handleBack}
                                className={`btn ${isEdit ? 'disabled' : ''}`}
                            >
                                <FontAwesomeIcon
                                    icon={faCircleLeft}
                                    className="icon-circle"
                                />
                                Previous quote
                            </Flex>
                            <Flex
                                align="center"
                                gap={4}
                                onClick={handleNext}
                                className={`btn ${isEdit ? 'disabled' : ''}`}
                            >
                                Next quote
                                <FontAwesomeIcon
                                    icon={faCircleRight}
                                    className="icon-circle"
                                />
                            </Flex>
                        </Flex>
                    )}
                </div>
            </div>
            <ModalSendMessage
                onClose={() => setIsModalVisible(false)}
                isVisible={isModalVisible}
            />
        </FooterQuoteDetailStyle>
    );
};

export default FooterQuoteDetail;
